(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      /*if(getCookie("enable_currency_codes") == "true"){
        document.querySelectorAll('.price:not(.fully-soldout)').forEach((price) => {
          if(price.dataset.currencyCode == 'CAD' || price.dataset.currencyCode == 'AUD'){
            if(price.querySelector('.price__current') != null){
              mainPrice = price.querySelector('.price__current').dataset.currencyCode;
              price.querySelector('.price__current').innerHTML = mainPrice;
            }
            if(price.querySelector('.price__was') != null){
              compareAtPrice = price.querySelector('.price__was').dataset.currencyCode;
              price.querySelector('.price__was').innerHTML = compareAtPrice;
            }
          }
        });
      }*/
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
